<style lang="scss">
    .breadcrumbs {
        position: relative;
        z-index: 50;
        padding: 20px 1.5rem 0;
        .breadcrumb-icon {
            margin-left: 7px;
        }
        .first-breadcrumb, .second-breadcrumb {
            margin-left: 5px;
        }
        .faded {
            opacity: 0.7;
        }
    }
</style>

<template>
    <div v-if="display" class="breadcrumbs" :style="$mainSecondaryTextStyle">
        <router-link v-if="homePage" class="home-breadcrumb faded" :to="{name: homePage.id}">{{homePage.name}}</router-link>
        <span v-if="firstBreadcrumb || secondBreadcrumbName" class="breadcrumb-icon">></span>
        <router-link v-if="firstBreadcrumb" class="first-breadcrumb" :class="{'faded': secondBreadcrumbName}" :to="{'name': firstBreadcrumb.name}">{{firstBreadcrumb.meta.pageName}}</router-link>
        <span v-if="firstBreadcrumb && secondBreadcrumbName" class="breadcrumb-icon">></span>
        <span v-if="secondBreadcrumbName" class="second-breadcrumb">{{secondBreadcrumbName}}</span>
    </div>
</template>

<script>
    import Configure from './../mixins/configure'

    export default {
        computed: {
            display() {
                if ((this.homePage && this.$route.path == this.homePage.link) || this.$route.path == '/' || this.$route.name == 'checkout' || this.$route.name == 'order' || this.$route.name == 'quotation') {
                    return false
                }

                return true
            },
            previousRoute() {
                return this.$store.state.previousRoute
            },
            homePage() {
                if (this.$store.state.currentConfig.homePage) {
                    return this.$store.state.currentConfig.homePage
                }
            },
            firstBreadcrumb() {
                if (this.singleMusicPage) {
                    if (this.previousRoute && this.previousRoute.meta.pageName) {
                        return this.previousRoute
                    }
                } else if (this.$route.meta.pageName) {
                    return this.$route
                }

                return false
            },
            firstBreadcrumbStyle() {
                if (!this.secondBreadcrumbName) {
                    return this.$mainSecondaryTextStyle
                }
                return {}
            },
            secondBreadcrumbName() {
                if (this.singleMusicPage) {
                    return this.$store.state.singleMusicPageName
                }
                return false
            },
            singleMusicPage() {
                return ['beat', 'song', 'soundkit', 'service', 'beat-tape'].includes(this.$route.name)
            }
        },
        mixins: [Configure]
    }
</script>
